import LeaveRightsGroupComponent from "../components/LeaveRightsGroup";
import useLeaveRightsGroup from "../hooks/useLeaveRightsGroup";

const LeaveRightsGroup = () => {
    const LeaveRightsGroupProps = useLeaveRightsGroup();
    return <LeaveRightsGroupComponent {...LeaveRightsGroupProps} />;
};

export default LeaveRightsGroup;
